import React from "react";
import { Box, Container, Typography } from "@mui/material";

interface TitleElementProps {
  headerOneText: string;
  headerTwoText: string;
}
export const TitleElement: React.FC<TitleElementProps> = ({
  headerOneText,
  headerTwoText,
}) => {
  return (
    <Box
      sx={{
        pt: { xs: 3, md: 2 },
        pb: { xs: 0, md: 0 },
        textAlign: "center",
        backgroundSize: "cover",
        backgroundPosition: "center",
        mt: { xs: 0, md: 4 },
        position: "relative",
        "&:before": {
          content: '""',
          position: "absolute",
          inset: 0,
        },
      }}
    >
      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="h1"
          component="h1"
          gutterBottom
          sx={{
            fontSize: {
              xs: "2.5rem", // ~36-48 px
              md: "4rem", // ~48-68 px
              lg: "4rem", // ~56-76 px
            },
            fontWeight: 700,
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            color: "#FFFFFF",
            textAlign: "center",
            // soft glow so the text stays legible on a dark / blurred photo
            textShadow: "0 4px 12px rgba(0,0,0,.45)",
            mb: { xs: 4, md: 4 },
            mx: "auto", // centre within Container—no extra margins needed
          }}
        >
          {headerOneText}
        </Typography>
        <Typography
          variant="h2"
          component="h2"
          gutterBottom
          sx={{
            fontSize: {
              xs: "1.25rem", // ~16-20 px
              md: "1.75rem", // ~18-24 px
            },
            fontWeight: 300,
            lineHeight: 1.35,
            letterSpacing: 0,
            color: "rgba(255,255,255,.84)", // lighter tone than h1 for visual hierarchy
            textAlign: "center",
            mb: { xs: 3, md: 4 },
            mx: "auto",
            maxWidth: 700,
            px: 1,
          }}
        >
          {headerTwoText}
        </Typography>
      </Container>
    </Box>
  );
};
